import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PhonePipe, SharedDesktopModule } from '@brightside-web/shared/desktop';
import { BrightsideUiModule, CellSeparatorType } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-sweepstakes-amoe',
    imports: [CommonModule, BrightsideUiModule, SharedDesktopModule, TranslateModule],
    templateUrl: './sweepstakes-amoe.component.html',
    styleUrls: ['./sweepstakes-amoe.component.scss'],
    providers: [PhonePipe]
})
export class SweepstakesAmoeComponent {
  clientDetails: { fName: string; lName: string; phone: string };

  constructor(private _route: ActivatedRoute, private _phonePipe: PhonePipe) {}

  ngOnInit() {
    this.clientDetails = {
      fName: this._route.snapshot.queryParams['fName'] || '',
      lName: this._route.snapshot.queryParams['lName'] || '',
      phone: this._phonePipe.transform(this._route.snapshot.queryParams['phone']),
    };
  }
}
